import AssessmentShareLink from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/AssessmentShareLink/AssessmentShareLink";

export default AssessmentShareLink;
